<template>
  <div class="chaozhilibao">
    <el-dialog
      :show-close="false"
      :visible="dialogVisible"
      width="860px"
      :modal-append-to-body="false"
      custom-class="mainDialogStyle"
      @open="onShow"
      @close="onHide"
    >
      <div class="content">
        <div class="box">
          <div class="title">选择礼包</div>
          <div class="itemBox">
            <item
              v-for="(item, index) in list"
              :itemData="item"
              :type="index"
              :isActive="bundleId === item.bundleId"
              :key="item.bundleId"
              @click.native="bundleClick(item)"
            />
          </div>
        </div>
        <div class="button" @click="buy"></div>
        <div class="close" @click="onHide"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import item from "./item.vue";
export default {
  components: {
    item,
  },
  data() {
    return {
      bundleId: 0,
      list: [],
    };
  },
  created() {
    this.getBundleList();
  },
  computed: {
    ...mapState("chaozhilibao", ["dialogVisible"]),
    item() {
      return (
        this.list.find((res) => res.bundleId == this.bundleId) || {
          bundleId: null,
          bundleName: "", //礼包名称
          originalPrice: null, //原价
          price: null, //价格
          voucherTemplates: [], //券列表
        }
      );
    },
  },
  methods: {
    ...mapActions("chaozhilibao", ["onShow", "onHide"]),
    async postBundleBuy() {
      const { status, info } = await this.$api.postBundleBuy({
        bundleId: this.bundleId,
      });
      if (status === 200) {
        this.$message({
          type: "success",
          message: info,
        });
        this.onHide()
        this.getAccount();
      } else {
        this.$message({
          type: "error",
          message: info,
        });
      }
    },
    async buy() {
      try {
        await this.$store.dispatch("user/buy", this.item.price);
        this.postBundleBuy();
      } catch (error) {
          this.onHide()
      }
    
    },
    async getBundleList() {
      const { status, info, data } = await this.$api.getBundleList({ type: 2 });
      if (status == 200) {
        this.list = data;
        if (!this.bundleId) {
          this.bundleId = data[0].bundleId;
        }
        return;
      }
      this.$message({
        type: "error",
        message: info,
      });
    },
    bundleClick({ bundleId }) {
      this.bundleId = bundleId;
    },
  },
};
</script>

<style scoped lang="scss">
.chaozhilibao {
  .content {
    background-image: url(~@/assets/image/chaozhilibao/bg.webp);
    height: 580px;
    width: 860px;
    background-size: 100%;
    position: relative;
    .box {
      width: 860px;
      height: 336px;
      position: absolute;
      left: 0;
      bottom: 86px;
      padding: 0 30px;
      .title {
        font-family: "Noto Sans SC";
        font-size: 16px;
        font-weight: 500;
        line-height: 60px;
        display: flex;
        align-items: center;
        letter-spacing: 0em;

        font-variation-settings: "opsz" auto;
        font-feature-settings: "kern" on;
        color: #262626;
      }
      .itemBox {
        display: flex;
        gap: 16px;
      }
    }
    .button {
      width: 240px;
      height: 60px;
      position: absolute;
      bottom: 48px;
      left: 0;
      right: 0;
      margin: auto;
      cursor: pointer;
    }
    .close {
      position: absolute;
      bottom: 0px;
      left: 0;
      right: 0;
      margin: auto;
      width: 28px;
      height: 28px;
      cursor: pointer;
    }
  }
}
</style>
